import { Component, OnInit, ViewChild } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import moment from 'moment';
import { NgxSpinnerService } from 'ngx-spinner';
import {
  DialogService,
  DynamicDialogConfig,
  DynamicDialogRef,
} from 'primeng/dynamicdialog';
import { FileUpload } from 'primeng/fileupload';
import { BoatSailor } from 'src/app/models/boat-sailor';
import { Sailor } from 'src/app/models/sailor';
import { ToastService } from 'src/app/services/toast.service';
import { ValidatorsUtil } from 'src/app/services/validators.util';
import { MessageUtil } from 'src/app/utils/message.util';
import { CustomerCatracasComponent } from '../../customer/customer-catracas/customer-catracas.component';
import { Licence } from './../../../../models/license';
import { BoatSailorService } from './../../../../services/boat-sailor.service';
import { SailorService } from './../../../../services/sailor.service';

@Component({
  selector: 'app-sailor-form',
  templateUrl: './sailor-form.component.html',
  styleUrls: ['./sailor-form.component.scss'],
})
export class SailorFormComponent implements OnInit {
  @ViewChild('upload', { static: false }) upload: FileUpload;
  selectedTab: number = 0;
  sailor = new Sailor();

  boatSailors: BoatSailor[] = [];

  isNew: boolean;

  sailorForm = new UntypedFormGroup({});
  boatsTable: BoatSailor[] = [];
  errorMessage: string;
  dadosPrincipais: any;
  licenseForm = new UntypedFormGroup({});

  readonlyForm=false;
  accessCategoryId: number;

  constructor(
    public dialogRef: DynamicDialogRef,
    private config: DynamicDialogConfig,
    private messageUtil: MessageUtil,
    private spinner: NgxSpinnerService,
    private sailorService: SailorService,
    private boatSailorService: BoatSailorService,
    private toastService: ToastService,
    private validatorsUtil: ValidatorsUtil,
    private dialog: DialogService,
  ) {}

  ngOnInit(): void {
    if (this.config.data?.user?.id) {
      const sailor: Sailor = this.config.data.user.sailor;
      Object.keys(sailor).map((key) => {
        if (sailor[key] === undefined || sailor[key] === null) {
          this.sailor[key] = '';
        } else {
          this.sailor[key] = sailor[key]; //}
        }
      });
      this.sailor.user.id = this.config.data.user.id;
      this.sailor.user.email = this.config.data.user.email;
      if (this.sailor.status!=="CADWEB"){
        this.readonlyForm=true;
      }
      this.startFormLicense(this.sailor?.licence);
      this.getListBoatSailor();
      this.accessCategoryId = this.config.data.accessCategoryId
    } else {
      this.sailor = new Sailor();
      this.sailor.user.email = '';
      this.startFormLicense();
    }
  }

  getListBoatSailor(): void {
    this.spinner.show();
    this.boatSailorService
      .getListBoatSailorByUserId(this.sailor.user.id)
      .subscribe(
        (data: any) => {
          this.boatsTable = data as BoatSailor[];
        },
        (error) => {
          this.spinner.hide();
          const exception = error.error.data.exception;
          this.messageUtil.generateMessage(
            exception.type,
            exception.title,
            exception.message
          );
        },
        () => this.spinner.hide()
      );
  }

  receiveDados($event): void {
    this.dadosPrincipais = $event;
  }

  receiveLicense($event): void {
    this.licenseForm = $event;
  }

  receiveBoatSailor($event): void {
    this.boatsTable = $event;
  }

  async save() {
    if (!this.validaForm()){
      return
    }

    try {
      this.dadosPrincipais.boatsDados
        .get('phone')
        .setValue(
          this.dadosPrincipais.boatsDados
            .get('phone')
            .value.replace(/([^\d])+/gim, '')
        );
    } catch (e) {}

    const type = this.dadosPrincipais.boatsDados.get('typesSailor').value;
    const accessCategory = this.dadosPrincipais.boatsDados.get('accessCategory')?.value;

    // Monta o payload a partir de uma cópia dos valores, sem mutar o form vivo.
    // (Antes, limpar typesSailor e remover o controle accessCategory direto no
    // FormGroup limpava o campo "tipo de marinheiro" na tela e, numa nova tentativa
    // após um save com erro, quebrava o save silenciosamente. Ver EBUG-209.)
    const sailorDados = { ...this.dadosPrincipais.boatsDados.value };
    sailorDados.typesSailor = [];
    delete sailorDados.accessCategory;

    const sendObj = {
      sailorDados: sailorDados,
      license: this.licenseForm.value,
      boatSailor: this.boatsTable,
      typesSailor: type,
      accessCategory: accessCategory,
      accessGroup: accessCategory
    };

    this.saveDados(sendObj);
  }

  saveDados(dados: any): void {
    this.spinner.show();
    this.sailorService.saveWeb(dados).subscribe(
      (data: any) => {
        this.dialogRef.close(data);
        this.toastService.success('Marinheiro salvo com sucesso.');
        if (data?.catracas.length > 0) {
          this.openIntegration(data);
        }
        this.spinner.hide();
      },
      (error) => {
        this.spinner.hide();
        // Falha do backend pode não vir no formato esperado (ex.: 500/NPE).
        // Sempre exibe uma mensagem em vez de engolir o erro silenciosamente. Ver EBUG-209.
        const exception = error?.error?.data?.exception;
        this.messageUtil.generateMessage(
          exception?.type || 'error',
          exception?.title || 'SUMMARY.ERROR',
          exception?.message || 'Não foi possível salvar o marinheiro. Tente novamente ou contate o suporte.'
        );
      },
      () => this.spinner.hide()
    );
  }

  openIntegration(data): void {
    this.dialog.open(CustomerCatracasComponent, {
      data: {
        customer: null,
        sailor: data,
      },
      header: 'Integração das Catracas',
      width: '80%',
      height: '80%',
    });
  }

  startFormLicense(license?: Licence) {

    if (!license?.id){
      license = new Licence();
    }
    if (license?.expiration && license?.expiration!=null){
      license.expiration = moment(license.expiration).utc(true).toDate();
    }
    this.licenseForm = new UntypedFormGroup({
      id: new UntypedFormControl(license.id),
      register: new UntypedFormControl(license.register),
      country: new UntypedFormControl(license.country),
      state: new UntypedFormControl(license.state),
      city: new UntypedFormControl(license.city),
      file: new UntypedFormControl(license.file),
      expiration: new UntypedFormControl(license.expiration),
      typeLicense: new UntypedFormControl(license.typeLicense),
    });
  }

  validaForm(): boolean {
    const federalIdType = this.dadosPrincipais.boatsDados.get('federalIdType').value;
    const documentCountry = this.dadosPrincipais.boatsDados.get('documentCountry').value;
    const isForeigner = federalIdType === 'Foreigner' || documentCountry !== 'BR';
    
    if (!isForeigner) {
      let federalIdNumber = this.dadosPrincipais.boatsDados.get('federalId').value;
      let isValidFederalId = this.validatorsUtil.cpfCnpjValidator(federalIdNumber);
      if (!isValidFederalId) {
        this.messageUtil.generateMessage('warning', 'SUMMARY.WARNING', 'CPF/CNPJ inválido.');
        return false;
      }
    }

    if (this.dadosPrincipais.boatsDados.status === "VALID") {
      return true;
    } else {
      // Marca todos os controles como touched para que os campos inválidos
      // fiquem destacados (borda vermelha + mensagem), e não apenas o aviso
      // geral. Cobre os Dados Gerais e o Endereço (que tem form próprio no
      // componente app-address-temp). Ver EBUG-209.
      this.dadosPrincipais.boatsDados.markAllAsTouched();
      this.dadosPrincipais.addressForm?.markAllAsTouched();
      this.messageUtil.generateMessage('warning', 'SUMMARY.WARNING', 'Existem campos obrigatórios vazios.');
      return false;
    }
  }


}
